import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CultUnifaunReturnsService {
  constructor(protected http: HttpClient) {}

  public createReturn(data): Observable<any> {
    return this.http.post<any>('unifaun-returns/create-return-shipment', data);
  }

  public getPrintsForShipment(shipmentId: string): Observable<any> {
    return this.http.get<any>(this.getPrintsForShipmentUrl(shipmentId));
  }

  getPrintsForShipmentUrl(shipmentId: string): string {
    return `unifaun-returns/shipments/${shipmentId}/prints`;
  }

  getPrintsForShipmentNoUrl(shipmentNo: string): string {
    return `unifaun-returns/prints-by-shipment-no/${shipmentNo}`;
  }

  openShipmentPdfNewWindow(shipmentPrint: ShipmentPrints) {
    const newPdfWindow = window.open('', 'Print');
    const content = encodeURIComponent(shipmentPrint.firstPrintContents);
    const iframeStart = "<iframe width='100%' height='100%' src='data:application/pdf;base64, ";
    const iframeEnd = "'></iframe>";
    newPdfWindow.document.write(iframeStart + content + iframeEnd);
    newPdfWindow.document.close();
  }
}

export class ShipmentPrints {
  id: string;
  name: string;
  extra: any;
  firstPrintContents: any;
  firstPrintId: string;
  shipmentId: string;
}
